export default function getExtraExportFields({ exportFields, mapping }) {
    if (Array.isArray(exportFields) && mapping) {
        return exportFields
            .filter((field) => !mapping[field.evertransitField])
            .sort((a, b) => a.order - b.order);
    }
    return [];
}
